
import { defineComponent } from 'vue'

import ReportAIReviewIssueFalsePositiveMutation from '~/apollo/mutations/issue/reportAiReviewIssueFalsePositive.gql'

import type { FetchResult } from 'apollo-link'
import type { ReportAiReviewIssueFalsePositiveMutation } from '~/types/types'

export default defineComponent({
  name: 'IgnoreAiReviewIssueFalsePositive',
  emits: ['close', 'ignore'],
  props: {
    aiReviewIssueId: {
      type: String,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false,
      comment: ''
    }
  },
  methods: {
    close(): void {
      this.$emit('close')
    },
    async confirm(): Promise<void> {
      this.isLoading = true
      try {
        const response: FetchResult<ReportAiReviewIssueFalsePositiveMutation> =
          await this.$applyGraphqlMutation(ReportAIReviewIssueFalsePositiveMutation, {
            input: { aiReviewIssueId: this.aiReviewIssueId, comment: this.comment }
          })
        if (response.data?.reportAiReviewIssueFalsePositive?.ok) {
          this.$toast.success('AI Review issue reported as false positive.')
          this.$emit('ignore', [this.aiReviewIssueId])
          this.close()
        } else {
          throw new Error('Received a non-ok response')
        }
      } catch (e) {
        this.$logErrorAndToast(
          e as Error,
          'Something went wrong while reporting this false positive.'
        )
      } finally {
        this.isLoading = false
      }
    }
  }
})
